import { Route, Routes } from 'react-router-dom';
import { Layout, ScrollToTop } from './components/Layout';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Rides } from './pages/Rides';
import { Courier } from './pages/Courier';
import { Captains } from './pages/Captains';
import { Safety } from './pages/Safety';
import { Support } from './pages/Support';
import { LegalPage } from './pages/LegalPage';
import { LegalHub } from './pages/LegalHub';
import { PaymentStatus } from './pages/PaymentStatus';
import { NotFound } from './pages/NotFound';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="services/rides" element={<Rides />} />
          <Route path="services/courier" element={<Courier />} />
          <Route path="captains" element={<Captains />} />
          <Route path="safety" element={<Safety />} />
          <Route path="support" element={<Support />} />
          <Route path="legal" element={<LegalHub />} />
          <Route path="terms" element={<LegalPage documentKey="terms" />} />
          <Route path="privacy" element={<LegalPage documentKey="privacy" />} />
          <Route path="fares-cancellations-refunds" element={<LegalPage documentKey="fares-cancellations-refunds" />} />
          <Route path="captain-terms" element={<LegalPage documentKey="captain-terms" />} />
          <Route path="courier-prohibited-items" element={<LegalPage documentKey="courier-prohibited-items" />} />
          <Route path="account-deletion" element={<LegalPage documentKey="account-deletion" />} />
          <Route path="complaints" element={<LegalPage documentKey="complaints" />} />
          <Route path="payment/return" element={<PaymentStatus status="return" />} />
          <Route path="payment/cancel" element={<PaymentStatus status="cancel" />} />
          <Route path="legal/:slug" element={<LegalPage />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}
